import { useState, useEffect } from 'react';

const useMobile = (breakpoint: number = 1000) => {
  const [isMobile, setIsMobile] = useState<boolean>(false); 

  useEffect(() => {
    if (typeof window === "undefined") return; 

    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    // Set initial state after mount
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
};

export default useMobile;
